
const m = window.require("truth-helpers/helpers/lt");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
